// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"styles_footerActions___mZWH","footerDisclaimer":"styles_footerDisclaimer__UneGF","footer":"styles_footer__gef6s"};